import moment from 'moment/moment'
import Refund from '../../components/Modal/refund/Refund'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import api, { customFuncsApi } from '../../api'
import Layout from '../../components/Layout'
import { get } from 'lodash'
import { ErrorModal, SuccessModal } from '../../components/Modal'
import ConfirmModal from '../../components/ComfirmModal'
import { BG_COLOR } from '../../constants/colors'
import { formatNumberInput, removeSpaces } from '../../helpers/formatNumber'

const Convert = () => {
	const { getMe } = useSelector((state) => state.main)

	const employeeID = getMe?.EmployeeID

	const [form, setForm] = useState({
		DocDate: moment().format('YYYY-MM-DD'),
		Type: 'UsdToUzs',
		CashSumUzs: '',
		CashSumUsd: '',
	})
	const successModalRef = useRef()
	const errorRef = useRef()

	const [stateCurrencyRate, setStateCurrencyRate] = useState(1)
	const [currencyLoading, setCurrencyLoading] = useState(false)
	const [schot1, setSchot1] = useState()
	const [schot2, setSchot2] = useState()
	const [refundLoading, setRefundLoading] = useState(false)
	const [accountsData, setAccountsData] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [confirmationMessage, setConfirmationMessage] = useState('')

	const handleOpenModal = () => {
		setConfirmationMessage([
			{
				name: 'Дата:',
				value: form.DocDate,
			},
			{
				name: 'Курс:',
				value: stateCurrencyRate,
			},
			{
				name: 'Наличная сумма uzs:',
				value: form.CashSumUzs,
			},
			{
				name: 'Счет расхода:',
				value: form.Type === 'UsdToUzs' ? schot2 : schot1,
			},
			{
				name: 'Наличная сумма usd:',
				value: form.CashSumUsd,
			},
			{
				name: 'Счет расхода:',
				value: form.Type === 'UsdToUzs' ? schot1 : schot2,
			},
		])
		setShowModal(true)
	}

	const getUSD = () => {
		setCurrencyLoading(true)
		api
			.post(`SBOBobService_GetCurrencyRate`, {
				Currency: 'UZS',
				Date: moment(),
			})
			.then((res) => {
				setStateCurrencyRate(JSON.parse(res.data))
			})
			.catch((err) => {
				errorRef.current?.open(JSON.stringify(err))
			})
			.finally(() => {
				setCurrencyLoading(false)
			})
	}

	useEffect(() => {
		getUSD()
	}, [])

	const handleTypeChange = (e) => {
		const newType = e.target.value
		setForm((prevState) => {
			if (newType === 'UsdToUzs') {
				const usdValue =
					prevState.CashSumUsd ||
					(prevState.CashSumUzs / stateCurrencyRate).toFixed(2)
				return {
					...prevState,
					Type: newType,
					CashSumUsd: usdValue,
					CashSumUzs: (usdValue * stateCurrencyRate).toFixed(2),
				}
			} else {
				const uzsValue =
					prevState.CashSumUzs ||
					(prevState.CashSumUsd * stateCurrencyRate).toFixed(2)
				return {
					...prevState,
					Type: newType,
					CashSumUzs: uzsValue,
					CashSumUsd: (uzsValue / stateCurrencyRate).toFixed(2),
				}
			}
		})
	}

	const handleSumChange = (e) => {
		const value = removeSpaces(e.target.value)
		setForm((prevState) => {
			if (prevState.Type === 'UsdToUzs') {
				return {
					...prevState,
					CashSumUsd: value,
					CashSumUzs: (value * stateCurrencyRate).toFixed(2),
				}
			} else {
				return {
					...prevState,
					CashSumUzs: value,
					CashSumUsd: (value / stateCurrencyRate).toFixed(2),
				}
			}
		})
	}

	const handleRefund = ({ DocDate, Type, CashSumUzs, CashSumUsd }) => {
		const body = {
			DocDate: DocDate,
			Type: Type,
			[Type === 'UsdToUzs' ? 'CashUsdAccount' : 'CashUzsAccount']: schot1,
			[Type === 'UsdToUzs' ? 'CashUzsAccount' : 'CashUsdAccount']: schot2,
			CashSumUzs: +removeSpaces(CashSumUzs),
			CashSumUsd: +removeSpaces(CashSumUsd),
		}

		console.log(body)

		setRefundLoading(true)
		customFuncsApi
			.post(`addMoneyChange`, body)
			.then(() => {
				successModalRef.current?.open('Платеж успешно произведен!')
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setRefundLoading(false)
			})
	}

	useEffect(() => {
		api
			.get(
				`ChartOfAccounts?$filter=U_User eq ${employeeID} or U_User2 eq ${employeeID}&$select=Code,Name,AcctCurrency,U_User,U_User2`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=10000',
					},
				},
			)
			.then((res) => {
				setAccountsData(JSON.parse(res.data).value)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}, [])

	const schot1List = accountsData?.filter((v) =>
		form?.Type === 'UsdToUzs'
			? v?.AcctCurrency === 'USD'
			: v?.AcctCurrency === 'UZS',
	)

	const schot2List = accountsData?.filter((v) =>
		form?.Type === 'UsdToUzs'
			? v?.AcctCurrency === 'UZS'
			: v?.AcctCurrency === 'USD',
	)

	return (
		<Layout>
			<Refund
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div
					className={
						'container mx-auto pt-10 h-[calc(100vh-80px)] flex flex-col items-center justify-center'
					}
				>
					<div className="mb-[100px]">
						<h2 className={'text-center mb-5'}>{'Конвертатция'}</h2>
						<div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
							<input
								type="date"
								placeholder="Date"
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								value={form.DocDate}
								onChange={(v) =>
									setForm((prevState) => ({
										...prevState,
										DocDate: v.target.value,
									}))
								}
							/>
							<input
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								value={stateCurrencyRate}
								onChange={(v) => setStateCurrencyRate(v.target.value)}
							/>
							<input
								type="text"
								placeholder="Cумма"
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								value={formatNumberInput(
									form.Type === 'UsdToUzs' ? form.CashSumUsd : form.CashSumUzs,
								)}
								onChange={handleSumChange}
							/>
							<div className={'flex gap-5'}>
								<select
									className={'border-[1px] border-[#DFE2E9"] p-2 rounded-md'}
									value={form.Type}
									onChange={handleTypeChange}
								>
									<option value="UsdToUzs">{'USD'}</option>
									<option value="UzsToUsd">{'UZS'}</option>
								</select>
								<div className="relative">
									<input
										type="text"
										list="productName"
										placeholder={'Со счета'}
										className={
											'border-[1px] border-[#DFE2E9"] p-2 rounded-md flex-1'
										}
										value={form.numberCard}
										onChange={(v) => setSchot1(v.target.value)}
									/>
									<datalist id="productName">
										{schot1List?.map((v, i) => (
											<option
												key={i}
												label={`${get(v, 'Name', '')} , ${get(v, 'Code', '')}`}
												value={get(v, 'Code', '')}
											/>
										))}
									</datalist>
								</div>
							</div>
							<input
								type="text"
								placeholder="Другая валюта"
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								disabled
								value={
									form.Type === 'UsdToUzs'
										? formatNumberInput(removeSpaces(form.CashSumUzs)) + ' UZS'
										: formatNumberInput(removeSpaces(form.CashSumUsd)) + ' USD'
								}
							/>
							<div className="relative">
								<input
									type="text"
									list="productName2"
									placeholder={'На счет'}
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md flex-1'
									}
									value={form.numberCard}
									onChange={(v) => setSchot2(v.target.value)}
								/>
								<datalist id="productName2">
									{schot2List?.map((v, i) => (
										<option
											key={i}
											label={`${get(v, 'Name', '')} , ${get(v, 'Code', '')}`}
											value={get(v, 'Code', '')}
										/>
									))}
								</datalist>
							</div>
						</div>
						<div className="centerCard">
							<button
								className="btnY disabled:cursor-not-allowed disabled:bg-gray-300 hover:bg-green-600 hover:text-white border-[4px] border-green-600 disabled:border-gray-300 disabled:border-gray-300"
								disabled={
									form.DocDate === '' ||
									form.Type === '' ||
									form.CashSumUzs === '' ||
									form.CashSumUsd === '' ||
									currencyLoading ||
									refundLoading
								}
								onClick={() => {
									handleOpenModal()
								}}
							>
								{'Да'}
							</button>
						</div>
					</div>
				</div>
				<SuccessModal getRef={(r) => (successModalRef.current = r)} />
				<ErrorModal getRef={(r) => (errorRef.current = r)} />
			</Refund>
			<ConfirmModal
				show={showModal}
				data={confirmationMessage}
				onConfirm={() => {
					setShowModal(false)
					handleRefund(form)
				}}
				onCancel={() => {
					setShowModal(false)
				}}
			/>
		</Layout>
	)
}

export default Convert

// import React from 'react'
// import Layout from '../../components/Layout'
//
// const MyComponent = () => {
// 	return (
// 		<Layout>
// 			<div className={'p-12'}>Not available</div>
// 		</Layout>
// 	)
// }
//
// export default MyComponent
